import * as React from 'react';
import { injectIntl, InjectedIntlProps, FormattedMessage } from 'react-intl';
import './styles.css';
import logoImage from '../../images/logo-3.png';
import { ABOUT_PATH, CONTACT_PATH } from '../../constants';

export default injectIntl((props: InjectedIntlProps) => {
    return (
        <header className="topHeader public container-fluid">
            <nav className="navbar navbar-expand-lg navbar-dark">
                <div className="col-lg-5 col-md-3 col-sm-12">
                    <a className="navbar-brand" href="/">
                        <img src={logoImage} width={150} alt="Harmonize logo"/>
                    </a>
                </div>

                <div className="col-lg-7 col-md-9 col-sm-12">
                    <div className="topItem">
                        <ul>
                            <li key="nav3">
                                <a href={ABOUT_PATH}><FormattedMessage id="public.nav.about" defaultMessage="About Us" /></a>
                            </li>
                            <li key="nav4">
                                <a href={CONTACT_PATH}><FormattedMessage id="public.nav.contact" defaultMessage="Contact Us" /></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
});



// WEBPACK FOOTER //
// ./src/public/shared/NavBar.tsx